module.exports = __webpack_public_path__ + "img/delay_8.edc760e6.svg";